module.exports = __webpack_public_path__ + "img/hallway.db0762a.svg";